// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/more-than-half-the-days.svg';

export const MoreThanHalfTheDays = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
